import api from "@/api";
import { GET_COUNTERS, SAVE_COUNTERS } from "./types";

export default {
  [GET_COUNTERS]: async ({ commit }) => {
    const resp = await api.counters.getCounters();

    commit(GET_COUNTERS, await resp.data);
    return resp.data;
  },

  [SAVE_COUNTERS]: async ({ commit }, data) => {
    const resp = await api.counters.saveCounters({ data });
    commit(GET_COUNTERS, await resp.data);
    return resp.data;
  }
};
